import { CLEOS_API_BASE, CLEOS_API_VERSION } from 'config';
import { createHttpClient } from './utils';

export default createHttpClient(`${CLEOS_API_BASE}${CLEOS_API_VERSION}`, { convertEmptyStrings: true });
